import React, { lazy, Suspense } from 'react'
import { Route, Routes, Navigate } from 'react-router-dom'
import { useSettings } from '../../hooks/useSetting'


// Component Imports
const Dashboard = lazy(() => import("../../pages/dashboard/Dashboard"));
const Users = lazy(() => import("../../pages/users/Users"))
const Platforms = lazy(() => import("../../pages/platforms/Platforms"))
const UpdatePlatform = lazy(() => import("../../pages/platforms/update_platform/UpdatePlatform"))
const CreatePlatform = lazy(() => import("../../pages/platforms/create_platform/CreatePlatform"))
const Phonenumbers = lazy(() => import("../../pages/phonenumbers/Phonenumbers"))
const Withdrawals = lazy(() => import("../../pages/withdrawals/Withdrawals"))
const Sms = lazy(() => import("../../pages/sms/Sms"))
const AppConfigSettings = lazy(() => import("../../pages/app_config_settings/AppConfigSettings"))
const Charts = lazy(() => import("../../pages/charts/Charts"))

const UserRoutes = () => {

    // const { settings } = useSettings()
    // const routesConfig = [
    //     {
    //         path: 'stats/mdr-report',
    //         element: <Dashboard />,
    //         // authName: permissionsName.stats_report.name
    //     },
    // ]


    return (
        <Suspense>
            <Routes>
                <Route path="dashboard" element={<Dashboard />} />
                <Route path="users" element={<Users />} />
                <Route path="platforms" element={<Platforms />} />
                <Route path="platforms/create" element={<CreatePlatform />} />
                <Route path="platforms/:id/update" element={<UpdatePlatform />} />
                <Route path="phonenumbers" element={<Phonenumbers />} />
                <Route path="withdrawals" element={<Withdrawals />} />
                <Route path="sms" element={<Sms />} />
                <Route path="app-config-settings" element={<AppConfigSettings />} />
                <Route path="charts" element={<Charts />} />
                {/* {routesConfig.map((route, index) => {
                    if (
                        route.authName &&
                        (Array.isArray(route.authName)
                            ? route.authName.every(name => !settings.userPermission.includes(name))
                            : !settings.userPermission.includes(route.authName))
                    )
                        return null // Skip rendering this route if not authenticated
                    return <Route key={index} path={route.path} element={route.element} />
                })} */}
                {/* <Route path="fake" element={<Fake />} /> */}
                {/* <Route path="*" element={<Navigate to={'/'} />} /> */}
                {/* <Route path="*" element={<Navigate to={'/stats/mdr'} />} /> */}
                <Route path="*" element={<Navigate to="/dashboard" />} />
            </Routes>
        </Suspense>
    )

}

export default UserRoutes
